import React, { useEffect } from "react";
import { Outlet } from "react-router-dom";

import Navigation from "../../../../../components/navigations/client/detail/medical/navigation";
import useParentLoaderData from "../../../../../hooks/useParentLoaderData";
import { NavigationHistoryService } from "../../../../../services/navigation-history-service";

export default () => {
  const { _case } = useParentLoaderData(2);

  useEffect(() => {
    const navService = new NavigationHistoryService();
    navService.save("client-detail", "/medical/health-insurance");
  }, []);

  return (
    <Navigation activeTab="health-insurance" _case={_case}>
      Health Insurance
      <Outlet />
    </Navigation>
  );
};
